import React, { useContext, useEffect, useRef, useState } from "react";

// plugin imports
import { ReactLenis, useLenis } from "lenis/react";
import { cancelFrame, frame } from "framer-motion";
import { useLocation } from "@reach/router";

// style imports

// component imports
import { LayoutContext } from "../../context/layoutContext";

// svg imports

// component
export default function SmoothScroll({ children }) {
	const { navMenuOpen } = useContext(LayoutContext);

	const lenisRef = useRef(null);

	const lenis = useLenis();
	const { pathname } = useLocation();

	useEffect(() => {
		lenis?.scrollTo(0, { immediate: true });
	}, [pathname, lenis]);

	useEffect(() => {
		function update(data) {
			const time = data.timestamp;
			lenisRef.current?.lenis?.raf(time);
		}

		frame.update(update, true);

		return () => cancelFrame(update);
	}, []);

	useEffect(() => {
		if (navMenuOpen) {
			lenis?.stop();
		} else {
			lenis?.start();
		}
		return () => {
			lenis?.start();
		};
	}, [lenis, navMenuOpen]);

	const [isUsingMouse, setIsUsingMouse] = useState(false);
	useEffect(() => {
		function handleWheel(e) {
			function isLikelyMouseWheel(e) {
				// Check if deltaMode is in "lines" (1) or "pages" (2), which points to a mouse wheel
				if (e.deltaMode !== 0) return true;

				// Check for large, integer steps characteristic of a traditional mouse wheel
				const looksLikeMouseStep =
					Math.abs(e.deltaY) > 30 && Math.abs(e.deltaX) === 0;

				// Pinch-to-zoom on some platforms sets ctrlKey, do not treat as scroll pan
				const isPinch = e.ctrlKey === true || e.metaKey === true;

				// If it looks like a mouse step and is not a pinch gesture, it is likely a mouse wheel
				return looksLikeMouseStep && !isPinch;
			}

			setIsUsingMouse(isLikelyMouseWheel(e));
			window.removeEventListener("wheel", handleWheel);
		}

		window.addEventListener("wheel", handleWheel);
		return () => window.removeEventListener("wheel", handleWheel);
	}, []);

	return (
		<ReactLenis
			root
			options={{ autoRaf: false, smoothWheel: isUsingMouse }}
			ref={lenisRef}
		>
			{children}
		</ReactLenis>
	);
}
